<template>
  <div class="content">
    <div class="title" style="margin-bottom: 16px;">代理商信息：{{title}}</div>
    <el-form :model="queryParams" ref="queryForm"  :inline="true">
      <el-form-item prop="productName">
        <el-input
          v-model="queryParams.productName"
          placeholder="请输入套餐名称"
          clearable
          style="width: 240px"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item prop="productType">
        <el-select v-model="queryParams.productType" filterable clearable placeholder="请输入套餐类型">
          <el-option v-for="item in productTypes" :key="item.key" :label="item.value" :value="item.key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button
          type="primary"
          icon="el-icon-plus"
          @click="openSelectProdcut"
          v-hasPermi="['agent:customProduct:save']"
        >单套餐直接配置</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button
          type="warning"
          icon="el-icon-close"
          @click="handleClose"
        >关闭</el-button>
      </el-col>
    </el-row>

    <el-table v-loading="loading" border :data="productList" :row-class-name="tableRowClassName" >
      <el-table-column type="index" align="center" />
      <el-table-column label="套餐ID" prop="id" align="center" :show-overflow-tooltip="true" />
      <el-table-column label="代理商名称" prop="companyName" min-width="160" align="center" :show-overflow-tooltip="true" >
        <template slot-scope="scope">
            <span>[{{scope.row.username}}]{{scope.row.companyName}}</span>
        </template>
      </el-table-column>
      <el-table-column label="套餐名称" align="center" min-width="160" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <div class="stack-cell">
            <div class="stack-line">
              <span class="stack-value name-strong">{{ scope.row.productName }}</span>
            </div>
            <div class="stack-line">
              <span class="stack-label">套餐类型</span>
              <span class="stack-value">{{ scope.row.productType }}</span>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="运营商价格" align="center" min-width="320px">
          <template slot-scope="scope">
            <div
              class="price-row"
              v-for="(item,index) in scope.row.products"
              :key="index"
              :class="{ 'price-row--readonly': !canEditRow(scope.row) }"
            >
              <span class="operator-name">{{item.operatorName}}</span>
              <span class="price-block">
                <span class="price-label">运营商价格</span>
                <el-input-number
                  v-if="canEditRow(scope.row)"
                  size="mini"
                  v-model="item.price"
                  :min="0"
                  :precision="2"
                  :step="0.01"
                  :controls="false"
                  class="price-input"
                />
                <el-tag v-else size="small">{{item.price}}</el-tag>
              </span>
              <span class="price-block">
                <span class="price-label">加价价格</span>
                <el-tag size="small">{{!item.extraPrice? 0 : item.extraPrice}}</el-tag>
              </span>
              <el-button
                v-if="canEditRow(scope.row)"
                type="text"
                icon="el-icon-delete"
                class="op-delete"
                :loading="operatorLoading[scope.row.id + '_' + (item.operatorId || item.operatorName)]"
                @click="removeOperatorPrice(scope.row, item)"
              ></el-button>
            </div>
          </template>
      </el-table-column>
      <el-table-column label="套餐信息" align="center" min-width="160" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <div class="stack-cell">
            <div class="stack-line">
              <span class="stack-label">市场价格</span>
              <span class="stack-value">{{ scope.row.showPrice }}</span>  
            </div>
            <div class="stack-line">
              <span class="stack-label">总量/M</span>
              <span class="stack-value">{{ scope.row.flowCount == -1 ? '畅享' : scope.row.flowCount }}</span>
            </div>
            <div class="stack-line">
              <span class="stack-label">有效期</span>
              <span class="stack-value">{{ scope.row.validityTime }}天</span>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="类型/归属" align="center" min-width="100" :show-overflow-tooltip="true" >
        <template slot-scope="scope">
          <div class="stack-cell">
            <div class="stack-line">
              <el-tag v-if="scope.row.customProduct == '1'">单套餐直接配置</el-tag>
              <el-tag v-if="scope.row.customProduct == '2'" type="success">按套餐组分配</el-tag>
            </div>
            <div class="stack-line">
              <el-tag v-if="scope.row.source == '1'" type="info">当前代理商</el-tag>
              <el-tag v-if="scope.row.source == '2'" type="warning">继承上级代理商</el-tag>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" min-width="180" fixed="right" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <div class="op-stack">
            <el-button
              v-if="canEditRow(scope.row)"
              size="mini"
              type="text"
              :icon="rowLoading[scope.row.id] ? 'el-icon-loading' : 'el-icon-check'"
              :disabled="!isRowDirty(scope.row) || rowLoading[scope.row.id]"
              @click="saveRowPrice(scope.row)"
            >保存价格</el-button>
            <el-button
              v-if="canEditRow(scope.row) && isRowDirty(scope.row)"
              size="mini"
              type="text"
              icon="el-icon-refresh-left"
              @click="resetRowPrice(scope.row)"
            >撤销</el-button>
            <el-button
              size="mini"
              type="text"
              icon="el-icon-circle-close"
              @click="customProductCancel(scope.row)"
              v-hasPermi="['agent:customProduct:cancel']"
              v-if="scope.row.customProduct == '1' && scope.row.source=='1'"
            >删除自定义套餐</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="pageNum"
      :limit.sync="pageSize"
      @pagination="getList"
    />
    <select-product ref="select" :userId="queryParams.userId" @ok="handleQuery" />
  </div>
</template>

<script>
import {agentDetail,agentCustomProduct,productType, customProductCancel, updateCustomProducts } from "@/api/api";
import selectProduct from "./selectProduct";

export default {
  name: "AgentProduct",
  components: { selectProduct },
  data() {
    return {
      title: "",
      // 遮罩层
      loading: true,
      // 选中用户组
      userIds: [],
      // 非多个禁用
      multiple: true,
      // 总条数
      total: 0,
      // 代理商套餐表格数据
      productList: [],
      pageNum: 1,
      pageSize: 10,
      // 查询参数
      queryParams: {
        userId: undefined,
        productName: undefined,
        productType: undefined
      },
      productTypes:[],
      // 行级原始价格快照，用于检测 dirty / 撤销
      productPriceSnapshot: {},
      // 行级提交 loading
      rowLoading: {},
      // 单运营商删除 loading：key = `${rowId}_${operatorKey}`
      operatorLoading: {}
    };
  },
  created() {
    const userId = this.$route.params && this.$route.params.userId;
    if (userId) {
      sessionStorage.setItem('agentProduct', userId);
      this.queryParams.userId = userId;
      this.getList();
    }else{
      this.queryParams.userId = sessionStorage.getItem('agentProduct');
      this.getList();
    }
    this.productTypeList();
    this.initAgentDetail();

  },
  watch: {
    // 监听路由中userId参数变化
    '$route.params.userId'(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        sessionStorage.setItem('agentProduct', newVal);
        this.queryParams.userId = newVal;
        this.resetQuery(); // 重置搜索条件
        this.initAgentDetail();

      }
    }
  },
  methods: {
    // 获取数据
    initAgentDetail(){
      agentDetail({userId : this.queryParams.userId}).then(res=>{
        let username = res.data.data.agent.username;
        let company = res.data.data.agent.companyName;
        this.title = "[" + username + "]" + company;
      });
    },
    /** 查询代理商套餐列表 */
    getList() {
      this.loading = true;
      this.productList = [];
      this.productPriceSnapshot = {};
      let params = {
        model: {
          ... this.queryParams
        },
        page: this.pageNum,
        pageSize: this.pageSize
      }
      agentCustomProduct(params).then(res => {
          this.productList = res.data.data.records;
          this.total = res.data.data.total;
          // 为每一行做价格快照，作为 dirty 检测 / 撤销 的基准
          this.productList.forEach(row => {
            // 兜底 extraPrice 为 0，方便输入和比对
            if (Array.isArray(row.products)) {
              row.products.forEach(p => {
                if (p.extraPrice === null || p.extraPrice === undefined || p.extraPrice === '') {
                  p.extraPrice = 0;
                }
              });
            }
            this.snapshotRow(row);
          });
          this.loading = false;
        }
      );
    },

    //套餐类型列表
    productTypeList(){
      productType().then(res =>{
        this.productTypes = res.data.data;
      })
    },
    // 返回按钮
    handleClose() {
      const obj = { path: "/partners/agent" };
      this.$tab.closeOpenPage(obj);
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    openSelectProdcut() {
      this.$refs.select.show();
    },
    /** 取消自定义套餐价格 */
    customProductCancel(row) {
      let userId = this.queryParams.userId
      this.$modal.confirm('确认要删除"' + row.productName + '"设置的自定义价格？').then(function() {
        return customProductCancel({ userId: userId, productId: row.id });
      }).then(() => {
        this.getList();
        this.$modal.msgSuccess("取消授权成功");
      }).catch(() => {});
    },
    /** 删除单个运营商的自定义价格 */
    removeOperatorPrice(row, item) {
      const operatorKey = item.operatorId || item.operatorName;
      const loadingKey = row.id + '_' + operatorKey;
      this.$modal.confirm('确认要删除「' + row.productName + '」下 [' + item.operatorName + '] 的自定义价格？').then(() => {
        this.$set(this.operatorLoading, loadingKey, true);
        return customProductCancel({
          userId: this.queryParams.userId,
          productId: row.id,
          operatorName: item.operatorName
        });
      }).then(res => {
        if (res.data && res.data.code === 200) {
          this.$modal.msgSuccess(`[${item.operatorName}] 价格已删除`);
          const idx = row.products.findIndex(p => (p.operatorId || p.operatorName) === operatorKey);
          if (idx >= 0) row.products.splice(idx, 1);
          this.snapshotRow(row);
          if (!row.products.length) {
            this.getList();
          }
        } else {
          this.$modal.msgError((res.data && res.data.msg) || '删除失败');
        }
      }).catch(err => {
        if (err && err !== 'cancel') {
          console.error('removeOperatorPrice error', err);
          this.$modal.msgError('删除失败，请稍后再试');
        }
      }).then(() => {
        this.$set(this.operatorLoading, loadingKey, false);
      });
    },
    // 行是否可编辑：本级 + 自定义套餐
    canEditRow(row){
      return row.customProduct == '1' && row.source == '1';
    },
    // 缓存一份原始产品价格(深拷贝，避免引用)
    snapshotRow(row){
      this.$set(this.productPriceSnapshot, row.id, JSON.parse(JSON.stringify(row.products || [])));
    },
    // 行内价格是否被改动（与快照对比，仅比较可编辑的运营商价格）
    isRowDirty(row){
      const snap = this.productPriceSnapshot[row.id];
      if (!snap || !Array.isArray(row.products)) return false;
      if (snap.length !== row.products.length) return true;
      for (let i = 0; i < row.products.length; i++) {
        const a = row.products[i];
        const b = snap[i];
        if (!b) return true;
        const aPrice = Number(a.price || 0);
        const bPrice = Number(b.price || 0);
        if (Math.abs(aPrice - bPrice) > 0.0001) return true;
      }
      return false;
    },
    // 撤销当前行的修改
    resetRowPrice(row){
      const snap = this.productPriceSnapshot[row.id];
      if (!snap) return;
      // 用 splice 触发响应式更新
      row.products.splice(0, row.products.length, ...JSON.parse(JSON.stringify(snap)));
    },
    // 未修改行加可视提示
    tableRowClassName({ row }){
      if (this.isRowDirty(row)) return 'row-dirty';
      return '';
    },
    // 保存当前行的运营商价格 / 加价价格
    saveRowPrice(row){
      if (!this.isRowDirty(row)) return;
      this.$set(this.rowLoading, row.id, true);
      const payload = {
        userId: this.queryParams.userId,
        productId: row.id,
        products: (row.products || []).map(p => ({
          operatorName: p.operatorName,
          price: Number(p.price || 0)
        }))
      };
      updateCustomProducts(payload).then(res => {
        if (res.data && res.data.code === 200) {
          this.$modal.msgSuccess(`[${row.productName}] 价格已保存`);
          // 更新快照为最新值，"撤销" 和 dirty 状态自动复位
          this.snapshotRow(row);
          // 仅刷新当前行的本地数据，避免整页 getList 闪烁
          // 如果需要彻底拉新，可调用 this.getList();
        } else {
          this.$modal.msgError((res.data && res.data.msg) || '保存失败');
        }
      }).catch(err => {
        console.error('saveRowPrice error', err);
        this.$modal.msgError('保存失败，请稍后再试');
      }).finally(() => {
        this.$set(this.rowLoading, row.id, false);
      });
    }
  }
};
</script>

<style scoped>
::v-deep .row-dirty > td {
  background-color: #fdf6ec !important;
}
.price-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 0;
  border-bottom: 1px dashed #ebeef5;
}
.price-row:last-child {
  border-bottom: none;
}
.price-row .operator-name {
  flex: 0 0 80px;
  text-align: right;
  color: #606266;
  font-weight: 600;
}
.price-row .price-block {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.price-row .price-label {
  color: #909399;
  font-size: 12px;
}
.price-input {
  width: 110px;
}
.op-delete {
  /* margin-left: auto; */
  color: #f56c6c;
  padding: 2px 4px;
}
.price-row--readonly .operator-name {
  color: #303133;
}
.stack-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 4px 0;
}
.stack-line {
  display: flex;
  align-items: center;
  gap: 8px;
}
.stack-label {
  color: #909399;
  font-size: 12px;
}
.stack-value {
  color: #303133;
  font-weight: 600;
}
.name-strong {
  font-weight: 700;
  color: #303133;
}
.op-stack {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}
</style>